import { Form, Select } from "antd";
import React from "react";

import "./FormItemSelect.scss";

const { Option } = Select;

interface FormItemInputProps {
  name: string;
  placeholder?: string;
  label: string;
  rules: { required: boolean; message?: string };
  defaultValue?: string;
  disabled?: boolean;
  items: { id: string; label: string }[];
  isSettingInput?: boolean;
  showSearch?: boolean;
}

const FormItemSelect: React.FC<FormItemInputProps> = ({
  name,
  placeholder,
  rules,
  label,
  defaultValue,
  disabled,
  items,
  isSettingInput,
  showSearch,
}) => {
  return (
    <Form.Item
      className={`form-item__select`}
      name={name}
      label={label}
      rules={[{ required: rules.required, message: rules.message }]}
    >
      <Select
        className={`select ${isSettingInput && "settings"}`}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        variant={"borderless"}
        showSearch={showSearch}
        optionFilterProp={"children"}
      >
        {items.map((el) => (
          <Option value={el.id} key={el.id}>
            {el.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default FormItemSelect;
